module.exports = __webpack_public_path__ + "static/media/998155.61ca5446.jpg";